import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { Taxes180Model } from './model-180.model';
import { environment } from '../../../../../environments/environment';
import { ApiResponse } from '../../../../models/base';

const TAXES_FISCAL_MODEL = '/taxes/fiscal/model/';
const TAXES_FISCAL_MODEL_TXT = '/taxes/fiscal/model/txt/';
const TAXES_FISCAL_MODEL_XML = '/taxes/fiscal/model/xml/';

@Injectable({
  providedIn: 'root',
})
export class Model180Service {
  private readonly http = inject(HttpClient);

  public async getData(period: string, receiptNumber: string): Promise<Taxes180Model> {
    let params = new HttpParams();
    params = params.append('period', period);
    params = params.append('receiptNumber', receiptNumber);

    const response = await firstValueFrom(
      this.http.get<ApiResponse<Taxes180Model>>(environment.apiUrl + TAXES_FISCAL_MODEL + '180', {
        params,
      })
    );

    return response.data;
  }

  public async downloadTxt(modelo180: Taxes180Model): Promise<Blob> {
    const response = await firstValueFrom(
      this.http.post(environment.apiUrl + TAXES_FISCAL_MODEL_TXT + '180', modelo180, {
        responseType: 'blob',
      })
    );

    return new Blob([response], { type: 'text/plain' });
  }
}